<div class="modal-container">
  <motif-modal-title>
    <h3 class="modal-title">Buscador AML</h3>
    <button
      motifIconButton
      aria-label="Close modal"
      motif-modal-close
      >
      <app-dynamic-icon [icon]="'close'"></app-dynamic-icon>
    </button>
  </motif-modal-title>
  <motif-modal-content class="modal-aml-mercury-searcher-content">
    <section class="table-container">
      <div class="d-flex table-filters mt-1" #filterElement>
        <div class="filters-separator">
          <div class="filter-name-container">
            <motif-form-field class="flex-fill search-input">
              <input
                [disabled]="loadingTable"
                motifInput
                motifSearch
                type="text"
                placeholder="Buscar por cliente, engagement o individuo"
                aria-label="Search"
                [(ngModel)]="filter"
                (ngModelChange)="searchFilter()" />
            </motif-form-field>
          </div>
        </div>
      </div>
      <div class="cards-list">
        <motif-card
          orientation="horizontal"
          cardVariant="full-width"
          *ngFor="let item of paginatedData; let i = index"
          class="aml-entries-container">
          <motif-card-header>
            <div class="header-container">
              <div class="two-column-data">
                <span
                  class="motif-h3"
                  [tooltipConfig]="{
                    hideIconClose: true,
                    tooltipColor: 'alternate'
                  }"
                  motif-truncate
                  [maxWidth]="450"
                  >{{ item?.client_name }}</span
                >
                <ng-container *ngIf="isAmlFolderAllowed">
                  <motif-chip
                    [disabled]="!item?.aml_code"
                    [removeable]="false"
                    (click)="item?.aml_code && navigateTo(item?.aml_code)"
                    motif-tooltip
                    [customTemplate]="!item?.aml_code ? noAmlTooltip : null"
                    [placement]="'auto'"
                    [hideIconClose]="false"
                    [hideArrow]="false">
                    Ir carpeta AML
                  </motif-chip>
                  <ng-template #noAmlTooltip>
                    No hay carpeta AML asociada
                  </ng-template>
                </ng-container>
              </div>
              <div class="two-column-data">
                <span class="motif-h5"
                  >Engagement code: {{ item?.eng_code }}</span
                >
              </div>
              <div class="aml-entries-container-data">
                <div class="three-column-data">
                  <div class="d-flex flex-column">
                    <span class="motif-h5"><strong>Individuo</strong></span>
                    <ng-container *ngFor="let doc of item.docs">
                      <span class="motif-h5">{{ doc.doc_individual }}</span>
                    </ng-container>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="motif-h5"><strong>Tipo</strong></span>
                    <ng-container *ngFor="let doc of item.docs">
                      <span class="motif-h5">{{ doc.doc_type }}</span>
                    </ng-container>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="motif-h5"><strong>Fecha</strong></span>
                    <ng-container *ngFor="let doc of item.docs">
                      <span class="motif-h5">{{ doc.aml_doc_date }}</span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </motif-card-header>
        </motif-card>
      </div>

      <div
        class="pagination-container"
        *ngIf="paginatedData?.length > 0 && !loadingTable">
        <app-paginator
          [dataFiltered]="dataFiltered"
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          (pageChange)="handlePageChange($event)"
          (pageSizeChange)="updatePaginationSize($event)"></app-paginator>
      </div>
    </section>
    <div class="no-data-container">
      <h4
        *ngIf="paginatedData?.length === 0 && filter && !loadingTable"
        class="no-data">
        No hay datos disponibles para mostrar
      </h4>

      <app-card-message
        *ngIf="paginatedData?.length === 0 && !filter && !loadingTable"
        [title]="'Información AML disponible'"
        [messageType]="'info'"
        [message]="
          'A través de este buscador podrás comprobar si ya existe información de AML disponible en la base de datos de EY y así evitar volver a solicitarla al cliente.'
        " style="width: 100%;">
      </app-card-message>
      <tax-spinner
        *ngIf="loadingTable"
        class="d-flex justify-content-center wrapper-25 spinner-wrapper"></tax-spinner>
    </div>
  </motif-modal-content>
</div>
